export default "__VITE_ASSET__B7gFO2wm__"